const values = {
    "ARTICLE_CATEGORIES": "Categorias de Artículos",
    "NEW_ARTICLE_CATEGORY": "Nueva Categoria",
    "EDIT_ARTICLE_CATEGORY": "Editar Categoria",
    "NO_ARTICLE_CATEGORIES_TITLE": "No hay categorias!!!",
    "NO_ARTICLE_CATEGORIES_SUBTITLE": "Verifica si estás aplicando algún filtro",
    "ARTICLE_CATEGORY_FILTER_PLACEHOLDER": "Nombre, descripción",
    "REMOVE_ARTICLE_CATEGORY": "Eliminar categoria",
    "REMOVE_ARTICLE_CATEGORY_CONFIRMATION": "¿Está seguro que desea eliminar la categoria?",
}

export default values;